import { EnvironmentService } from "@angular-monorepo/environment";
import { HttpClient } from "@angular/common/http";
import { inject, Injectable, signal } from "@angular/core";
import { catchError, finalize, tap } from 'rxjs';
import { Router } from '@angular/router';

export enum CVUStatus {
  Pending = "2",
  Expired = "3",
  Approved = "5",
  Denied = "6",
}

export interface CvuVoucher {
  status: 'ACTIVE' | 'INACTIVE';
  account: {
    country: string,
    currency: string,
    name: string,
    number: string,
  };
  processorInstructions: {
    generalInstructions: {
      method: string;
      devices: {
        code: string;
        instructions: string[];
      }[];
    }[];
  };
}

@Injectable({
  providedIn: 'root'
})
export class VoucherCvuService {
  private router = inject(Router);
  private readonly environmentService = inject(EnvironmentService);
  private readonly http = inject(HttpClient);
  private readonly apiUrl = this.environmentService?.env?.apiConfig?.virtualAccountsApiUrl;

  isLoading = signal<boolean>(false);

  getVoucher(operationId: string, verification: string) {
    this.isLoading.set(true);
    return this.http
      .get<CvuVoucher>(`${this.apiUrl}/accounts/${operationId}`, {
        headers: { verification },
      })
      .pipe(
        tap(() => this.isLoading.set(false)),
        catchError((err) => {
          this.router.navigateByUrl('/payin-voucher/error');
          throw err;
        }),
        finalize(() => this.isLoading.set(false))
      );
  }

}
